(function () {
    function init() {
        var select = document.getElementById('products-per-page');
        if (!select) return;

        select.addEventListener('change', function () {
            var value = select.value;
            var url = new URL(window.location.href);

            if (!value || value === '12') {
                url.searchParams.delete('view');
            } else {
                url.searchParams.set('view', value);
            }
            url.searchParams.delete('page');

            window.location.href = url.toString();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
